import { render } from "./HintButton.vue?vue&type=template&id=0bae45c9"
import script from "./HintButton.vue?vue&type=script&lang=js"
export * from "./HintButton.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./HintButton.vue?vue&type=style&index=0&id=0bae45c9&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "C:\\OpenServer\\domains\\front-studixy.dm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__